import { useContext } from "react";
import { Stack, Collapse, Typography } from "@mui/material";
import moment from "moment";
import { AuthContext } from "../../../Context/AuthContext";
import { TransitionGroup } from "react-transition-group";
import { currencyFormat } from "../../../Function/DynamicFn";

const ViewItemList = ({ listItemData }) => {
  const { t } = useContext(AuthContext);

  // console.log("listItemData::")

  return (
    <Stack direction="column" spacing={2.7}>
      <Stack
        spacing={2}
        direction="row"
        alignItems="center"
        sx={{ borderBottom: "1px solid gray", paddingRight: 3 }}
      >
        <Typography className={t("class-name-field-title")} width="25%">
          {t("thead_other_materials")}
        </Typography>

        <Typography className={t("class-name-field-title")} width="15%">
          {t("thead_start_date")}
        </Typography>

        <Typography className={t("class-name-field-title")} width="15%">
          {t("thead_end_date")}
        </Typography>

        <Typography
          className={t("class-name-field-title")}
          width="15%"
          sx={{ textAlign: "right" }}
        >
          {t("thead_amount")}
        </Typography>

        <Typography
          className={t("class-name-field-title")}
          width="5%"
          sx={{ textAlign: "right" }}
        >
          {t("thead_qty")}
        </Typography>

        <Typography
          className={t("class-name-field-title")}
          width="10%"
          sx={{ textAlign: "right" }}
        >
          {t("thead_discount")}
        </Typography>

        <Typography
          className={t("class-name-field-title")}
          width="15%"
          sx={{ textAlign: "right" }}
        >
          {t("thead_total")}
        </Typography>
      </Stack>

      {/* List with TransitionGroup */}
      <TransitionGroup>
        {listItemData?.map((item, index) => {
          // console.log("item::", item);
          return (
            <Collapse key={index}>
              <Stack
                spacing={2}
                direction="row"
                alignItems="center"
                sx={{ mb: 1, paddingRight: 3 }}
              >
                <Typography sx={{ fontSize: 15 }} width="25%">
                  {`${item?.groupFeeId?.title}: ${item?.groupFeeId?.price} $`}
                </Typography>

                <Typography sx={{ fontSize: 15 }} width="15%">
                  {item?.startDate &&
                    moment(item?.startDate).format("DD MMM YYYY")}
                </Typography>

                <Typography sx={{ fontSize: 15 }} width="15%">
                  {item?.endDate && moment(item?.endDate).format("DD MMM YYYY")}
                </Typography>

                <Typography
                  sx={{ fontSize: 15, textAlign: "right" }}
                  width="15%"
                >
                  $ {currencyFormat(item?.price)}
                </Typography>

                <Typography
                  sx={{ fontSize: 15, textAlign: "right" }}
                  width="5%"
                >
                  {item?.qty}
                </Typography>

                <Typography
                  sx={{ fontSize: 15, textAlign: "right" }}
                  width="10%"
                >
                  $ {currencyFormat(item?.discount)}
                </Typography>

                <Typography
                  sx={{ fontSize: 15, textAlign: "right" }}
                  width="15%"
                >
                  $ {currencyFormat(item?.amount)}
                </Typography>
              </Stack>
            </Collapse>
          );
        })}
      </TransitionGroup>
    </Stack>
  );
};

export default ViewItemList;
